import PrototypeStudioLayout from '@shared/PrototypeStudioLayout';
import Loading from '@shared/Loading';
import { NetworkShell, PRODUCTION_REF_TABS, Size2MixTabs, TEST_PUC_NETWORK, useSize2MixRefNavigation, type ProductionRefTabId } from '@shared/size2mix-shell';
import { useProduction } from './hooks';
import EditorTab from './EditorTab';

export const meta = {
    title: 'Référence — Réseau > Production',
    description:
        'Éditeur de production du réseau PUC EDM, généré depuis les quatre sites réels.',
    tags: ['production', 'editor', 'reference'],
    author: 'dv5886',
    status: 'review' as const,
    category: 'production/editor',
    createdAt: '2026-10-10',
};

export default function RefNetworkProduction() {
    const nav = useSize2MixRefNavigation();
    const { data, isLoading } = useProduction();

    return (
        <PrototypeStudioLayout title={meta.title}>
            <NetworkShell network={TEST_PUC_NETWORK} activePage="production" onNavigate={nav.onNetworkNavigate} onPrimaryNavigate={nav.onPrimaryNavigate}>
                <Size2MixTabs<ProductionRefTabId> tabs={PRODUCTION_REF_TABS} activeId="editor" onChange={(id) => nav.goTo(PRODUCTION_REF_TABS.find((tab) => tab.id === id)!.target)} />
                {isLoading || !data ? (
                    <Loading text="Chargement de la production" scale="md" />
                ) : (
                    <EditorTab data={data} />
                )}
            </NetworkShell>
        </PrototypeStudioLayout>
    );
}
